import TextSetting from "./setting"

export default TextSetting
